const COOKIE_LOGGED = 'bsnm_loggedStatus';
const HOURS_COOKIE_DURATION = 1;
const DAYS_OF_DURATION = 1;

//ANCHOR CREATE COOKIE FOR PRIVACY E LOGGED (FOR LOGIN EVENT)
class CookieManager {
  static setCookie(name, value) {
    const encodedValue = encodeURIComponent(value)
    const expires = new Date(
      Date.now() + HOURS_COOKIE_DURATION * DAYS_OF_DURATION * 60 * 60 * 1000
    ).toUTCString()
    document.cookie = `${name}=${encodedValue}; expires=${expires}; path=/`
  }

  static getCookie(name) {
    const match = document.cookie.match(new RegExp(`(?:^|; )${name}=([^;]*)`))
    if (match) {
      const decodedValue = decodeURIComponent(match[1])
      if (decodedValue === '') return false
      return decodedValue
    }
    return false
  }

  static manageLogCookie(init) {
    if (THEME_INFO.logged == 'not_logged') {
      CookieManager.setCookie(COOKIE_LOGGED, 'not_logged');
      return;
    }
    let loggedCookie = CookieManager.getCookie(COOKIE_LOGGED)
    if (loggedCookie == 'not_logged') {
      CookieManager.setCookie(COOKIE_LOGGED, 'firstLog');
      window.GTM_PUSH({ event: 'user_logged_in' });
      return;
    }
    CookieManager.setCookie(COOKIE_LOGGED, 'logged');
    return;
  }
}

CookieManager.manageLogCookie();

//ANCHOR PAGEVIEW (INIT GA4)
window.GTM_PUSH({ event: 'page_viewed' }).then(() => {
    //ANCHOR VIEW_ITEM
    if (THEME_INFO.pageType == 'product') {
      GtmDataExtractor.sendViewEvent('gtm-view-item', {
        event: 'view_item',
        method: 'load',
      });
      /* not found on KAPPA theme
        setTimeout(() => {
          const el = document.getElementById('relatedColorSizes')
          if (el) {
            el.addEventListener('onSelectVariant', (event) => {
              window.eventFetch(
                window.THEME_INFO.productId,
                event.detail.variant.variantId,
                {
                  event: 'selected_variant',
                  method: 'selected',
                }
              )
            })
          }
        }, 2000)
      */
    }
    //ANCHOR VIEW_Item_list
    if (THEME_INFO.pageType == 'collection') {
      GtmDataExtractor.sendViewEvent('gtm-collections', {
        event: 'view_item_list',
        method: 'load',
      });
      document.addEventListener('collection:reloaded', function () {
        GtmDataExtractor.sendViewEvent('gtm-collections', {
          event: 'view_item_list',
          method: 'refresh',
        });
      });
    }
    else if (THEME_INFO.pageType == 'page') {
      notableElements = document.querySelectorAll('.gtm-elementList');
      notableElements.forEach(notableElement => {
        const section_id = notableElement.getAttribute('id');
        const container_identifier = '#' + section_id + ' .gtm-collection';
        GtmDataExtractor.sendViewEvent(container_identifier, {
          event: 'view_item_list',
          method: 'load',
        }, true);

      });
    }
    //ANCHOR CART_EVENTs
    document.addEventListener('cart:updated', function (evt) {
      const cart          = evt.detail.cart;
      //console.log('cart:', cart);
      const method        = THEME_INFO.pageType == 'cart' ? 'cart_page' : 'sidebar';
      const event         = cart.items_removed.length > 0 ? 'remove_from_cart' : 'add_to_cart';
      const productCart   = cart.items_removed.length > 0 ? cart.items_removed[0] : cart.items_added[0];
      const item          = cart.items.find((element) => element.key == productCart.view_key);
      const productHandle = item?.handle || evt?.detail?.handle;
      const variantId     = productCart.variant_id;

      const removedQty = event === 'remove_from_cart'
        ? cart.items_removed.reduce((total, item) => total + Number(item.quantity || 0), 0)
        : null;

      if (event == 'remove_from_cart' && removedQty > 1) {
        window.eventFetch(productHandle, variantId, {
          event:  event,
          method: method,
          removedQty: removedQty,
        });
      }
      else{
        window.eventFetch(productHandle, variantId, {
          event:  event,
          method: method,
        });
      }

    });
    document.addEventListener('ajaxProduct:added', function (evt) {
      const productHandle = evt.detail.productHandle;
      const variantId     = evt.detail.variantId;
      window.eventFetch(productHandle, variantId, {
        event:  'add_to_cart',
        method: 'pdp',
      });

    });
    if (THEME_INFO.pageType == 'search') {
      GtmDataExtractor.sendViewEvent('gtm-collections', {
        event:  'search',
        method: 'load',
      });
    }
});
